import 'codemirror/addon/hint/show-hint.css';

import 'codemirror/addon/hint/show-hint';

import CodeMirror from 'codemirror/lib/codemirror';

const Pos = CodeMirror.Pos;

const stringProps = (
    'charAt charCodeAt indexOf lastIndexOf substring substr slice trim trimLeft trimRight ' +
    'toUpperCase toLowerCase split concat match replace search'
).split(' ');

const arrayProps = (
    'length concat join splice push pop shift unshift slice reverse sort indexOf ' +
    'lastIndexOf every some filter forEach map reduce reduceRight '
).split(' ');

const funcProps = 'prototype apply call bind'.split(' ');

const javascriptKeywords = (
    'break case catch class const continue debugger default delete do else export extends false finally for function ' +
    'if in import instanceof new null return super switch this throw true try typeof var void while with yield'
).split(' ');

const filterKeywords = (
    'jsonlint JSHINT'
).split(' ');

const forAllProps = (obj, callback) => {
  if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) {
    for (let name in obj) {
      callback(name);
    }
  } else {
    for (let o = obj; o; o = Object.getPrototypeOf(o)) {
      Object.getOwnPropertyNames(o).forEach(callback);
    }
  }
};

const forEach = (arr, f) => {
  for (let i = 0, e = arr.length; i < e; ++i) {
    f(arr[i]);
  }
};

const arrayContains = (arr, item) => {
  if (!Array.prototype.indexOf) {
    let i = arr.length;
    while (i--) {
      if (arr[i] === item) {
        return true;
      }
    }
    return false;
  }
  return arr.indexOf(item) !== -1;
};

const getCompletions = (token, context, keywords, options) => {
  let found = [],
      start = token.string,
      global = (options && options.globalScope) || window;
  const maybeAdd = str => {
    if (str.lastIndexOf(start, 0) === 0 && !arrayContains(found, str) && !filterKeywords.includes(str)) {
      found.push(str);
    }
  };

  function gatherCompletions(obj) {
    if (typeof obj == 'string') forEach(stringProps, maybeAdd);
    else if (obj instanceof Array) forEach(arrayProps, maybeAdd);
    else if (obj instanceof Function) forEach(funcProps, maybeAdd);
    forAllProps(obj, maybeAdd);
  }

  if (context && context.length) {
    let obj = context.pop(), base;
    if (obj.type && obj.type.indexOf('variable') === 0) {
      if (options && options.additionalContext)
        base = options.additionalContext[obj.string];
      if (!options || options.useGlobalScope !== false)
        base = base || global[obj.string];
    } else if (obj.type === 'string') {
      base = '';
    } else if (obj.type === 'atom') {
      base = 1;
    } else if (obj.type === 'function') {
      if (
          global.jQuery != null &&
          (obj.string === '$' || obj.string === 'jQuery') &&
          typeof global.jQuery == 'function'
      )
        base = global.jQuery();
      else if (
          global._ != null &&
          obj.string === '_' &&
          typeof global._ == 'function'
      )
        base = global._();
    }
    while (base != null && context.length) base = base[context.pop().string];
    if (base != null) gatherCompletions(base);
  } else {
    // If not, just look in the global object, any local scope, and optional additional-context
    // (reading into JS mode internals to get at the local and global variables)
    for (let v = token.state.localVars; v; v = v.next) maybeAdd(v.name);
    for (let c = token.state.context; c; c = c.prev)
      for (let v = c.vars; v; v = v.next) maybeAdd(v.name);
    for (let v = token.state.globalVars; v; v = v.next) maybeAdd(v.name);
    if (options && options.additionalContext != null)
      for (let key in options.additionalContext) maybeAdd(key);
    if (!options || options.useGlobalScope !== false) gatherCompletions(global);
    forEach(keywords, maybeAdd);
  }
  return found;
};

const scriptHint = (editor, keywords, getToken, options) => {
  let cur = editor.getCursor(), token = getToken(editor, cur);
  if (/\b(?:string|comment)\b/.test(token.type)) {
    return;
  }

  const innerMode = CodeMirror.innerMode(editor.getMode(), token.state);
  if (innerMode.mode.helperType === 'json') {
    return;
  }

  token.state = innerMode.state;

  if (!/^[\w$_]*$/.test(token.string)) {
    token = {
      start: cur.ch,
      end: cur.ch,
      string: '',
      state: token.state,
      type: token.string === '.' ? 'property' : null,
    };
  } else if (token.end > cur.ch) {
    token.end = cur.ch;
    token.string = token.string.slice(0, cur.ch - token.start);
  }

  let tprop = token;
  let context = [];

  while (tprop.type === 'property') {
    tprop = getToken(editor, Pos(cur.line, tprop.start));

    if (tprop.string !== '.') {
      return;
    }

    tprop = getToken(editor, Pos(cur.line, tprop.start));
    context.push(tprop);
  }
  return {
    list: getCompletions(token, context, keywords, options),
    from: Pos(cur.line, token.start),
    to: Pos(cur.line, token.end),
  };
};

export const javascriptHint = (editor, options) => {
  return scriptHint(
      editor,
      javascriptKeywords,
      function(e, cur) {
        return e.getTokenAt(cur);
      },
      options,
  );
};